var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.componentClass, style: _vm.componentStyle }, [
    _c("label", { class: _vm.labelClass, attrs: { for: _vm.sluggedLabel } }, [
      _vm._v("\n    " + _vm._s(_vm.label) + "\n  "),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { class: _vm.inputWrapperClass },
      [
        _vm.hasIcon && _vm.isProcessing
          ? _c("font-awesome-icon", {
              attrs: {
                icon: _vm.$v6[_vm.iconStyle][_vm.isProcessingIconName],
                "fixed-width": "",
                spin: "",
              },
            })
          : _vm.hasIcon
          ? _c("font-awesome-icon", {
              attrs: {
                icon: _vm.$v6[_vm.iconStyle][_vm.iconName],
                "fixed-width": "",
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "input",
          _vm._b(
            {
              ref: "field",
              class: _vm.inputClass,
              attrs: {
                id: _vm.sluggedLabel,
                autofocus: _vm.autofocus,
                disabled: _vm.isDisabled,
                name: _vm.sluggedLabel,
                placeholder: _vm.placeholder,
                readonly: _vm.isReadOnly,
                required: _vm.isRequired,
                type: _vm.type,
              },
              domProps: { value: _vm.value.value },
              on: {
                click: _vm.handleClick,
                input: _vm.updateValue,
                blur: _vm.onBlur,
                focus: function ($event) {
                  return _vm.$emit("focus")
                },
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  $event.preventDefault()
                  return _vm.$emit("enter")
                },
              },
            },
            "input",
            _vm.$attrs,
            false
          )
        ),
      ],
      1
    ),
    _vm._v(" "),
    _vm.tip
      ? _c("p", { staticClass: "tip margin-top-2xs margin-bottom-0" }, [
          _vm._v("\n    " + _vm._s(_vm.tip) + "\n  "),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }